import { render, staticRenderFns } from "./sky-card.vue?vue&type=template&id=48987797"
import script from "./sky-card.vue?vue&type=script&lang=js"
export * from "./sky-card.vue?vue&type=script&lang=js"
import style0 from "./sky-card.vue?vue&type=style&index=0&id=48987797&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports